import RoomingListTemplate from "../../../templates/admin/roomingList";

const RoomingListScreen = () => {
  return <RoomingListTemplate />;
};

export default RoomingListScreen;
